/*
 *  form
 */

var variables = window.nffleet_variables;
var events = window.nffleet_events;

window.nffleet_form = function (formContent) {

    var didSubmit = false;
    var formIsValid = false;
    var fieldsToValidate = [];

    var form = document.createElement(variables.formTag);
    form.autocomplete = "off";

    var hideAfterSubmit = document.createElement(variables.divTag);
    hideAfterSubmit.classList.add("hide-after-submit");
    form.appendChild(hideAfterSubmit);

    var h2 = document.createElement(variables.h2Tag);
    h2.innerHTML = formContent.Form.Headline;
    hideAfterSubmit.appendChild(h2);

    var p = document.createElement(variables.pTag);
    p.innerHTML = formContent.Form.Description;
    hideAfterSubmit.appendChild(p);

    var fieldset = document.createElement(variables.fieldsetTag);
    hideAfterSubmit.appendChild(fieldset);

    for (var fieldIndex = 0; fieldIndex < formContent.Fields.length; fieldIndex++) {
        var field = formContent.Fields[fieldIndex];

        var classArray = null;

        if (fieldIndex === formContent.Fields.length - 1) {
            classArray = ["clear"];
        }

        var fieldElement = createFormElement(field.Id, field.Caption, field.Required, field.FullWidth, field.Type, classArray);
        fieldset.appendChild(fieldElement);
    }

    function createFormElement(id, labelName, isRequired, isFullWidth, inputType, classList) {
        var formElement = document.createElement(variables.divTag);
        formElement.classList.add("form-element");

        if (!isFullWidth) {
            formElement.classList.add("width-50");
        }

        if (classList !== null && classList !== undefined) {
            for (var cL = 0; cL < classList.length; cL++) {
                formElement.classList.add(classList[cL]);
            }
        }

        var elementLabel = document.createElement(variables.labelTag);
        elementLabel.classList.add("form-label");
        elementLabel.innerHTML = labelName;
        formElement.appendChild(elementLabel);

        var inputElement;

        if (inputType === variables.textareaTag) {
            var messageTextArea = document.createElement(variables.textareaTag);
            messageTextArea.cols = "40";
            messageTextArea.rows = "4";
            inputElement = messageTextArea;
        } else {
            inputElement = document.createElement(variables.inputTag);
            inputElement.type = inputType;
        }

        inputElement.id = id;
        inputElement.name = id;

        if (isRequired) {
            fieldsToValidate.push(inputElement);

            elementLabel.innerHTML = elementLabel.innerHTML + "*";
            inputElement.setAttribute(variables.requiredAttribute, variables.emptyString);
        }

        formElement.appendChild(inputElement);

        inputElement.addEventListener(variables.focusListener,
            function (e) {
                e.target.classList.remove(variables.invalidClass);
            });

        inputElement.addEventListener(variables.changeListener,
            function () {
                var invalidFields = fieldsToValidate.filter(function (e) {
                    return e.value === variables.emptyString || e.value === undefined || e.value === null;
                });
                formIsValid = invalidFields.length === 0;
            });

        return formElement;
    }
    
    var submitButton = document.createElement(variables.buttonTag);
    submitButton.classList.add("btn");
    submitButton.classList.add("btn-blue");
    submitButton.innerHTML = formContent.SubmitButtonText;
    hideAfterSubmit.appendChild(submitButton);
    
    submitButton.addEventListener(variables.clickListener, function (event) {
        event.preventDefault();

        submitButton.blur();

        if (!formIsValid) {
            fieldsToValidate.filter(function (e) {
                var invalid = e.value === variables.emptyString || e.value === undefined || e.value === null;
                if (invalid) {
                    e.classList.add(variables.invalidClass);
                }
            });
        } else if (!didSubmit) {
            var inputFields = fieldset.querySelectorAll("input,textarea");
            var query = variables.emptyString;

            for (var i = 0; i < inputFields.length; i++) {
                var inputField = inputFields[i];

                var name = inputField.name;
                var value = inputField.value;

                var newQuery = name + "=" + value;

                if (query !== variables.emptyString) {
                    newQuery = "&" + newQuery;
                }

                query = query + newQuery;
            }

            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState === 4) {
                    form.dispatchEvent(events.formSubmitted());
                    didSubmit = true;
                    fieldset.style.display = "none";
                    submitButton.innerHTML = formContent.CloseButtonText;

                    var response = JSON.parse(this.responseText);
                    h2.innerHTML = response.Headline;
                    p.innerHTML = response.Description;
                }
            };

            xhttp.open("POST", formContent.SubmitUrl, true);
            xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            xhttp.send(query);
        } else {
            form.dispatchEvent(events.destroy());
        }
    });

    return form;
}